import { render } from "./Spinner.vue?vue&type=template&id=503f075a&scoped=true"
const script = {}

import "./Spinner.css?vue&type=style&index=0&id=503f075a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-503f075a"]])

export default __exports__